import { Subject } from "rxjs";
import { filter, map } from "rxjs/operators";
import log2 from "../utils/log2";
import router from "../router";
import SYSTEM_PUBSUB from "../utils/systemPubSub";

const log = log2("WindowPubSub");
const messages = new Subject();

const inbox = messages.asObservable();
const SW_MESSAGE_TYPES = {
    OPEN_CHAT: "open_chat",
};
if (navigator.serviceWorker)
    navigator.serviceWorker.addEventListener("message", function (e) {
        log("serviceWorker.message", e.data);
        messages.next(e.data);
    });

const ServiceWorker_PUBSUB = {
    inbox,
    MESSAGE_TYPES: SW_MESSAGE_TYPES,
};

inbox
    .pipe(
        filter((x) => x.cmd === SW_MESSAGE_TYPES.OPEN_CHAT),
        map((x) => x.payload.conversationId)
    )
    .subscribe((conversationId) => {
        log("OPEN_CHAT", conversationId, router.currentRoute.path);
        if (router.currentRoute.path === "/chat") {
            SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.OPEN_CHAT, { conversationId });
        } else {
            router.push("/chat");
            setTimeout(() => {
                SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.OPEN_CHAT, { conversationId });
            }, 1000);
        }
    });

export default ServiceWorker_PUBSUB;
